/**
 * Copyright IBM Corp. 2016, 2020
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import PropTypes from 'prop-types';
import React from 'react';
import BrandsIndexListItem from './BrandsIndexListItem';

function BrandsIndexList({ items }) {
  return (
    <div className="catalog-categories-pane grid-view">
      <div className="category-section all_categories resource-card-group">
        {items.map(
          ({
            id,
            slug,
            description,
            article,
            categories,
            //  extLink
          }) => {
            const key = `${id}`;
            return (
              <BrandsIndexListItem
                key={key}
                id={id}
                slug={slug}
                description={description}
                categories={categories}
                article={article}
              //  extLink={extLink}
              />
            );
          }
        )}
      </div>
    </div>
  );
}

BrandsIndexList.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      article: PropTypes.string.isRequired,
      category: PropTypes.string,
      description: PropTypes.string
    })
  ),
};

export default BrandsIndexList;